import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import {
  LeaderboardPublicPort,
  type LoadMagicLinkPreflightParams,
  type LoadPublicLeaderboardParams,
} from '../../../domain/leaderboard/ports/leaderboard-public.port';
import type { PublicLeaderboardLoadOutcome } from '../../../domain/leaderboard/models/leaderboard-unavailable.model';
import type { MagicLinkPreflightOutcome } from '../../../domain/leaderboard/models/magic-link-preflight.model';
import { createStubPublicLeaderboard } from '../fixtures/public-leaderboard.stub.fixture';

/**
 * Temporary adapter: returns deterministic stub data. Replace with HTTP adapter + mapper when API is ready.
 */
@Injectable({ providedIn: 'root' })
export class LeaderboardPublicStubAdapter extends LeaderboardPublicPort {
  loadPublic(params: LoadPublicLeaderboardParams): Observable<PublicLeaderboardLoadOutcome> {
    const id = params.leaderboardId?.trim();
    if (!id || !Number.isFinite(params.commerceId) || params.commerceId <= 0) {
      return of({ status: 'unavailable', reason: 'missing_params' });
    }
    const data = createStubPublicLeaderboard({
      boardId: id,
      title: `Leaderboard ${id}`,
    });
    return of({ status: 'ok', board: data });
  }

  loadMagicLinkPreflight(params: LoadMagicLinkPreflightParams): Observable<MagicLinkPreflightOutcome> {
    const id = params.leaderboardId?.trim();
    const uid = params.uid?.trim();
    if (!id || !uid || !Number.isFinite(params.commerceId) || params.commerceId <= 0) {
      return of({ status: 'unavailable', reason: 'missing_params' });
    }
    return of({
      status: 'ok',
      termsAndConditionsUrl: undefined,
      participant: { uid, isActive: true },
      layoutPreview: { title: `Leaderboard ${id}` },
    });
  }
}
